/**
 * Firm User Permission Utilities
 *
 * Centralized logic for FIRM user route access control.
 * All allowed/denied routes and toast helpers live here.
 */

import { USER_TYPES } from '../constants/userTypes';

/**
 * Route patterns that FIRM users are allowed to access.
 * Tested against location.pathname.
 */
export const FIRM_ALLOWED_PATTERNS = [
  /^\/social(\/|$)/,
  /^\/adoption(\/|$)/,
  /^\/chat(\/|$)/,
  /^\/profile(\/|$)/,
  /^\/account\/preferences(\/|$)/,
  /^\/account\/profile(\/|$)/,
  /^\/dashboard(\/|$)/,
  /^\/notifications(\/|$)/,
  // Auth / public routes are never blocked by this guard
  /^\/auth\//,
  /^\/$/, // landing
];

/**
 * Returns true if the given pathname is allowed for a Firm user.
 * @param {string} pathname - e.g. location.pathname
 */
export const isFirmAllowedRoute = (pathname) => {
  return FIRM_ALLOWED_PATTERNS.some((pattern) => pattern.test(pathname));
};

/**
 * Fires a CustomEvent that the Navbar/App toast listener catches
 * to show an "access denied" message to the user.
 * @param {string} [message]
 */
export const showFirmAccessToast = (
  message = 'This page is not available for Firm accounts.'
) => {
  window.dispatchEvent(
    new CustomEvent('show-access-toast', {
      detail: { message, type: 'warning' },
    })
  );
};

/**
 * Returns true if the authenticated user is a FIRM account.
 * @param {string|null} userType - value from getUserType()
 */
export const isFirmUser = (userType) =>
  userType === USER_TYPES.FIRM || userType === 'FIRM' || userType === 'firm';
